import { useEffect } from 'react';
import { updateLoggerContext } from '@doxyme/analytics';
import {
  UserSubscriptionType,
  useGetSubscriptionTypeQuery,
} from '../../services';
import { getLogger } from '../../libs/logger';
import { type UseUserSubscriptionReturnType } from './useUserSubscription.types';
import { getUserPlanType } from './helpers/getUserPlanType';
import { useGetUserId } from '../../hooks/useCredentials';

const logger = getLogger('useUserSubscription');

export const useUserSubscription = (): UseUserSubscriptionReturnType => {
  const userId = useGetUserId();
  const { currentData, isLoading, error, isSuccess } =
    useGetSubscriptionTypeQuery(
      {
        userId,
      },
      {
        /*
        Skip request for patient side (if userId is not present).
        In future this request might be considered with taking a userId from room admin membership.
      */
        skip: !Boolean(userId),
      },
    );
  useEffect(() => {
    if (error) {
      logger.error('Failed to get subscription type (plan)');
    }
  }, [error]);
  const plan = currentData?.subscriptionType;
  const isPaidUser = plan !== undefined && plan !== UserSubscriptionType.Free;
  const userPlanType = getUserPlanType(plan);

  useEffect(() => {
    if (userPlanType !== undefined) {
      updateLoggerContext({
        planType: userPlanType,
      });
    }
  }, [userPlanType]);

  return {
    plan,
    isPaidUser,
    userPlanType,
    isLoading,
    isSuccess,
    isUpgradeButtonVisible: !isPaidUser,
    isSubscriptionTabVisible: true,
  };
};
